module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am468-3f6306aeddeb7ac70c4e6f7502828eb3.jpg";